export const RB_DATA = {
  COMMON: 'COMMON',
  HEADER: 'HEADER',
  WORK_HISTORY: 'WORK_HISTORY',
  EDUCATION: 'EDUCATION',
  SKILLS: 'SKILLS',
  SUMMARY: 'SUMMARY',
  EXTRA: 'EXTRA',
  EXTRA_CERTIFICATIONS: 'EXTRA_CERTIFICATIONS',
  EXTRA_LANGUAGES: 'EXTRA_LANGUAGES',
  EXTRA_CUSTOM: 'customSections',
};

export const RB_DEFAULT_KEY = {
  COMMON: 'COMMON_DEFAULT',
  HEADER: 'HEADER_DEFAULT',
  SUMMARY: 'SUMMARY_DEFAULT',
  EXTRA_DEFAULT: 'EXTRA_DEFAULT',
  CERTIFICATIONS: 'CERTIFICATIONS_DEFAULT',
  LANGUAGES: 'LANGUAGES_DEFAULT',
};

export const RB_DATA_FIELD = {
  COMMON: {
    JOB_LEVEL: 'COMMON_JOB_LEVEL',
    EDUCATION_LEVEL: 'COMMON_EDUCATION_LEVEL',
  },
  HEADER: {
    FIRST_NAME: 'HEADER_FIRST_NAME',
    LAST_NAME: 'HEADER_LAST_NAME',
    LOCATION: 'HEADER_LOCATION',
    ZIP_CODE: 'HEADER_ZIP_CODE',
    PHONE: 'HEADER_PHONE',
    EMAIL: 'HEADER_EMAIL',
    SOCIALS: 'HEADER_SOCIALS',
    PORTFOLIOS: 'HEADER_PORTFOLIOS',
  },
  WORK_HISTORY: {
    JOB_TITLE: 'WORK_HISTORY_JOB_TITLE',
    EMPLOYER: 'WORK_HISTORY_EMPLOYER',
    LOCATION: 'WORK_HISTORY_LOCATION',
    START_DATE: 'WORK_HISTORY_START_DATE',
    END_DATE: 'WORK_HISTORY_END_DATE',
    IS_CURRENT: 'WORK_HISTORY_IS_CURRENT',
    DESCRIPTION: 'WORK_HISTORY_DESCRIPTION',
    ORDER: 'WORK_HISTORY_ORDER',
  },
  EDUCATION: {
    SCHOOL_NAME: 'EDUCATION_SCHOOL_NAME',
    SCHOOL_NAME_NORMALIZED: 'EDUCATION_SCHOOL_NAME_NORMALIZED',
    SCHOOL_LOCATION: 'EDUCATION_SCHOOL_LOCATION',
    DEGREE: 'EDUCATION_DEGREE',
    FIELD_OF_STUDY: 'EDUCATION_FIELD_OF_STUDY',
    FIELD_OF_STUDY_NORMALIZED: 'EDUCATION_FIELD_OF_STUDY_NORMALIZED',
    GRADUATION_START_DATE: 'EDUCATION_GRADUATION_START_DATE',
    GRADUATION_END_DATE: 'EDUCATION_GRADUATION_END_DATE',
    IS_CURRENT: 'EDUCATION_IS_CURRENT',
    SUMMARY: 'EDUCATION_SUMMARY',
    ORDER: 'EDUCATION_ORDER',
  },
  SKILLS: {
    SKILL_NAME: 'SKILLS_SKILL_NAME',
  },
  SUMMARY: {
    DESCRIPTION: 'SUMMARY_DESCRIPTION',
    HEADLINE: 'SUMMARY_HEADLINE',
  },
  EXTRA: {
    INCLUDE_CERTIFICATIONS: 'INCLUDE_CERTIFICATIONS',
    INCLUDE_LANGUAGES: 'INCLUDE_LANGUAGES',
  },
  EXTRA_CERTIFICATIONS: {
    CERTIFICATION_DATE: 'EXTRA_CERTIFICATIONS_CERTIFICATION_DATE',
    CERTIFICATION_NAME: 'EXTRA_CERTIFICATIONS_CERTIFICATION_NAME',
  },
  EXTRA_LANGUAGES: {
    LANGUAGE_NAME: 'EXTRA_LANGUAGES_LANGUAGE_NAME',
  },
};

export const RB_DATA_SOCIALS = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  WHATSAPP: 'whatsapp',
};

export const RB_DATA_SOCIALS_TITLES = {
  [RB_DATA_SOCIALS.FACEBOOK]: 'Facebook',
  [RB_DATA_SOCIALS.TWITTER]: 'Twitter',
  [RB_DATA_SOCIALS.LINKEDIN]: 'LinkedIn',
  [RB_DATA_SOCIALS.INSTAGRAM]: 'Instagram',
  [RB_DATA_SOCIALS.YOUTUBE]: 'YouTube',
  [RB_DATA_SOCIALS.WHATSAPP]: 'WhatsApp',
};
